import { ButtonProps } from "./types";
import "./button.scss";

const Button = ({
  id,
  children,
  onClick,
  disabled,
  type = "button",
  className = "",
  fill = "solid",
  testId,
}: ButtonProps) => {
  const classes = [
    "default-button",
    fill === "solid" ? "solid-button" : "outline-button",
    className,
  ].join(" ");

  return (
    <button
      id={id}
      disabled={disabled}
      onClick={onClick}
      type={type}
      className={classes}
      data-testId={testId}
    >
      {children}
    </button>
  );
};

export default Button;
